import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PropertyFeature } from '../../../../../_helpers/property-feature-access';

@Component({
  selector: 'app-premium-feature-lock',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './premium-feature-lock.component.html',
  styleUrl: './premium-feature-lock.component.scss',
})
export class PremiumFeatureLockComponent {
  @Input() layout: PropertyFeature = 'intelligence';
  @Input() headline = '';
  @Input() description = '';
  @Input() ctaLabel = '';
  @Input() upgradeDestination = '/payment';

  get content() {
    return this.layout === 'intelligence' ? {
      headline: 'Know the true value before you make an offer.',
      description: 'Unlock fair market value, transaction history, land value analysis, and negotiation guidance with an Intelligence or Advisory plan.',
      ctaLabel: 'Unlock Circled Intelligence (CI)',
      cards: ['Fair Market Value', 'Asking Price Comparison', 'Transaction Data', 'UDS Analysis', 'Negotiation Potential', 'Market Insights'],
    } : {
      headline: 'Discover the investment potential of this property.',
      description: 'Unlock rental income insights, investment returns, and long-term property performance analysis.',
      ctaLabel: 'Unlock Investment Insights',
      cards: ['Rental Yield', 'Estimated Rental Income', 'ROI Analysis', 'Capital Appreciation', 'Investment Performance', 'Long-term Value'],
    };
  }
}
